import * as React from "react";
import GA4 from "react-ga4";
const ReactGA = GA4;

declare global {
  interface Window {
    YT: any;
    onYouTubeIframeAPIReady: (() => void) | undefined;
  }
}

export interface YoutubeProps {
  videoId: string;
  shouldtrack?: boolean;
  GAEventID?: string;
  GAEventValue?: string;
}

const YouTubeVideo: React.FC<YoutubeProps> = ({
  videoId,
  shouldtrack,
  GAEventID,
  GAEventValue,
}) => {
  const playerRef = React.useRef<any>(null);

  React.useEffect(() => {
    // Initialize player
    const initPlayer = () => {
      if (window.YT && window.YT.Player) {
        playerRef.current = new window.YT.Player("youtube-player", {
          videoId: videoId,
          events: {
            onStateChange: () => {
              if (shouldtrack) {
                ReactGA.event({
                  category: "Video",
                  action: "PlayStateChanged",
                  label: `${GAEventID} - ${GAEventValue}`,
                });
              }
            },
          },
        });
      }
    };

    // Load YouTube API if not loaded
    if (!window.YT) {
      const tag = document.createElement("script");
      tag.src = "https://www.youtube.com/iframe_api";
      document.body.appendChild(tag);
      window.onYouTubeIframeAPIReady = initPlayer;
    } else {
      initPlayer();
    }

    return () => {
      playerRef.current?.destroy();
      playerRef.current = null;
    };
  }, [videoId, GAEventID, GAEventValue, shouldtrack]);

  return <div id="youtube-player" />;
};
export default YouTubeVideo;
